import $ from 'jquery';

var loader = {
  showLoader: function () {
    $('#main-wrapper-row').addClass('show-loader');
    $('#main-wrapper-row').removeClass('hide-loader');
  },

  hideLoader: function () {
    setTimeout(function () {
      $('#main-wrapper-row').removeClass('show-loader').addClass('hide-loader');
    }, 1600);
  }
};

export default loader;
